/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useEffect, useState } from "react";

/**
 * Component to render a component without SSR.
 *
 * @param children: what to render inside the NoSSR component
 * @returns null if on the server, otherwise the children
 */
export const NoSSR = ({ children }: { children: React.ReactNode }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);
  return !isMounted ? null : <>{children}</>;
};
